import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// Redirección controlada de la ruta antigua /afiliacion al flujo canónico /afiliacion/solicitud.
// Solo se preservan parámetros permitidos y validados (sin reconstruir enlaces sensibles).
const ALLOWED_PARAMS = ['fuente', 'campania', 'seccion'];
const SAFE = /^[A-Za-z0-9_.-]{1,64}$/;

const AfiliacionRedirect = () => {
  const [params] = useSearchParams();
  const out = new URLSearchParams();
  ALLOWED_PARAMS.forEach((k) => {
    const v = params.get(k);
    if (v && SAFE.test(v)) out.append(k, v);
  });
  const qs = out.toString();
  return <Navigate to={`/afiliacion/solicitud${qs ? `?${qs}` : ''}`} replace />;
};

export default AfiliacionRedirect;
